import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		isLogin: localStorage.getItem('access_token') ? true : false,
		menus: [], // 权限菜单
	},
	mutations: { 
		// 存储权限菜单
		addMenus(state, list) {
			state.menus = list;
		},
		//荷载为true或false,是否登录
		checkLogin(state, isLog) {
			state.isLogin = isLog
		}
	},
	actions: {
		login(context, status) {
			context.commit("checkLogin", status);
		},
		exit(context, status) {
			context.commit("checkLogin", status);
			sessionStorage.clear()
		}
	},
	modules: {}
})